import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MeterDataStoreServiceDirective } from '@app/shared/services/store/meter-data-store.service';
import { MeterViewResponse } from '@app/shared/models/meter-data/meter-view';
import { MeterTypeDirection } from '@app/shared/enums';
import { EnergyTypes } from '@app/shared/models/energy-types';
import { MeterTypes } from '@app/shared/models/meter-types';
import { MeterDataService } from '@app/shared/services/api/meter-data.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { delay, uniqBy } from 'lodash';
import { forkJoin, Subscription } from 'rxjs';

@Component({
  selector: 'app-meter-data-info-dialog',
  templateUrl: './meter-data-info-dialog.component.html',
  styleUrls: ['./meter-data-info-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MeterDataInfoDialogComponent implements OnInit, OnDestroy {
  public energyTypes: Array<EnergyTypes> = [];
  public isLoading = true;
  public meterDirection = Object.values(MeterTypeDirection);
  public meterTypes: Array<MeterTypes> = [];
  public remoteReadingCount = 0;

  private meterDataStoreServiceEnergyTypesSubscription: Subscription = new Subscription();
  private meterDataStoreServiceMeterTypesSubscription: Subscription = new Subscription();

  constructor(
    private meterDataService: MeterDataService,
    private meterDataStoreServiceDirective: MeterDataStoreServiceDirective,
    private userMunicipalitiesService: UserMunicipalitiesService
  ) {}

  public ngOnInit(): void {
    this.meterEnergyService();
  }

  public ngOnDestroy(): void {
    this.meterDataStoreServiceMeterTypesSubscription.unsubscribe();
    this.meterDataStoreServiceEnergyTypesSubscription.unsubscribe();
  }

  public getMeterTypeImage(code: string): string {
    if (code === 'REMOTE_READING') {
      return 'remote';
    } else {
      return this.meterDataStoreServiceDirective.getMeterTypeImage(code);
    }
  }

  private meterEnergyService(): void {
    const currentMunicipalityKey = this.userMunicipalitiesService.currentMunicipality.key;

    this.meterDataStoreServiceMeterTypesSubscription = forkJoin([
      this.meterDataStoreServiceDirective.getMeterTypes(),
      this.meterDataService.getCountOfMetersWithSensor(currentMunicipalityKey),
    ]).subscribe(([meterTypes, meterWithSensor]: [MeterTypes[], MeterViewResponse]) => {
      this.meterTypes = uniqBy(meterTypes, (types: MeterTypes) => types.sortOrder);
      this.remoteReadingCount = meterWithSensor.maxRowCount;
      if (this.remoteReadingCount) {
        this.meterTypes.splice(1, 0, {
          code: 'REMOTE_READING',
          imageName: 'remote.svg',
          name: 'Modul zur Fernauslesung',
        } as MeterTypes);
      }
      this.meterTypes = uniqBy(this.meterTypes, (types: MeterTypes) => types.name);
      delay(() => {
        this.isLoading = false;
      }, 1000);
    });

    this.meterDataStoreServiceEnergyTypesSubscription = this.meterDataStoreServiceDirective.getEnergyTypes().subscribe((energyTypes: EnergyTypes[]) => {
      this.energyTypes = uniqBy(energyTypes, (types: EnergyTypes) => types.sortOrder);
      this.energyTypes = uniqBy(this.energyTypes, (types: EnergyTypes) => types.name);
    });
  }
}
